//View for the entire linked accounts section of 'Profile and Settings'

define('views/linkedaccounts/linkedaccounts',[
	'backbone',
	'views/_base/baseview',
	'text!views/linkedaccounts/linkedaccounts.html',
	'views/linkedaccounts/linkedcard',
	'models/linkedcards/linkedcard_collection',
	'models/accounts/bank',
	'models/shared/bankaccount/bankaccount',
	'models/securecontent/securecontent',
	'models/validator/cardnumberlinked',
	'models/validator/month',
	'models/validator/year',
	'models/validator/zipcode',
	'models/validator/cardlinkednickname',
	'views/shared/button/button',
	'models/shared/lookups/lookups',
	'models/fundtransfer/banktransfer',
	'views/shared/alerts/alert',
	'views/shared/modal/modal_modern',
	'views/shared/button/success_modal',
], function (
	Backbone,
	BaseView,
	Template,
	LinkedCardView,
	LinkedCardsModel,
	BankModel,
	LinkBankModel,
	SecureContent,
	LinkedCardValidator,
	MonthValidator,
	YearValidator,
	ZipcodeValidator,
	LinkedCardNicknameValidator,
	ButtonComponent,
	LookupsModel,
	BankTransferModel,
	AlertModalView,
	Modal,
	ButtonSuccessModalView
) {
	'use strict';

	return BaseView.extend({
		className: 'profile-content',
		tagName: 'div',
		isRender: true,
		template: _.template(Template),

		link_card: {
			form_active: false,
			form_invalid: false,
			credit_card: {
				number: {
					valid: null,
					value: null,
					empty: true,
					active: false,
					touched: false,
					complete: false,
				},
				exp: {
					valid: null,
					value: null,
					empty: true,
					active: false,
					touched: false,
					complete: false,
				},
				cvv: {
					valid: null,
					value: null,
					empty: true,
					active: false,
					touched: false,
					complete: false,
				},
				zip: {
					valid: null,
					value: null,
					empty: true,
					active: false,
					touched: false,
					complete: false,
				},
			},
		},

		events: {
			// Linked Card Events
			'click .js-link-card-btn': 'showLinkCardForm',
			'click .js-linked-account-add-form-save': 'saveNewCard',
			'click .js-linked-account-add-form-cancel': 'hideLinkCardForm',
			'blur .js-add-card-number': 'getCardType',
			'blur .js-add-card-zipcode': 'validateZipcode',

			// Link Card - Credit Card Validation
			'blur .js-card-number': 'cardNumberFormBlur',
			'blur .js-card-exp': 'cardExpFormBlur',
			'blur .js-card-cvc': 'cardCVVFormBlur',
			'blur .js-card-zip': 'cardZipFormBlur',

			'focus .js-card-number': 'cardNumberFormFocus',
			'focus .js-card-exp': 'cardExpFormFocus',
			'focus .js-card-cvc': 'cardCVVFormFocus',
			'focus .js-card-zip': 'cardZipFormFocus',

			'keydown .js-card-number': 'keydownValidateCardNumber',
			'keyup .js-card-number': 'keyupValidateCardNumber',
			'keydown .js-card-exp': 'keydownValidateExp',
			'keyup .js-card-exp': 'keyupValidateExp',
			'keydown .js-card-cvc': 'keydownValidateCvc',
			'keyup .js-card-cvc': 'keyupValidateCvc',
			'keydown .js-card-zip': 'keydownValidateZip',
			'keyup .js-card-zip': 'keyupValidateZip',

			// Bank Events
			'click .js-linked-accounts-bank-remove': 'removeBank',
			'click .js-linked-accounts-unverified-bank-remove': 'removeBank',
			'click .js-link-bank-btn': 'showLinkBankForm',
			'click .js-linked-account-add-bank-form-cancel': 'hideLinkBankForm',
			'click .js-linked-account-add-bank-form-save': 'saveNewBank',
			'click .js-linked-accounts-bank-verify': 'showVerifyBankForm',
			'click .js-linked-accounts-bank-edit': 'showBankReloadForm',

			'keyup .js-linked-bank-deposit-one': 'handleKeyupDepositOneAmount',
			'keyup .js-linked-bank-deposit-two': 'handleKeyupDepositTwoAmount',
			'blur .js-linked-bank-deposit-one': 'handleBlurDepositOneAmount',
			'blur .js-linked-bank-deposit-two': 'handleBlurDepositTwoAmount',
			'change .js-bank-reload': 'toggleReloadBankForm',
		},

		initialize: function (options) {
			options = options || {};

			this.cip_status = checkCipStatus();

			this.linked_card_views = [];

			this.bank_account_last4 = '';

			this.is_verifiable = false;

			this.elementName = options.elementName;

			BaseView.prototype.initialize(this);
		},

		render: function () {
			var that = this;

			// Carried over from settings.js
			if (pf.IsConsumerFinancial == true) {
				checkFinRegStatus(function () {
					that.$el.html(that.template());

					that.addExpYearsToLinkedCardForm();

					that.addLinkedCardFormButton();
				});
			} else {
				// TODO: What do we want to tell the user here?
				pf.navigate('#profile');
			}

			return this;
		},

		loadData: function () {
			var that = this;

			pf.controller.loadAccounts(function () {
				that.getLinkedCards();
				that.getBank();
			});
		},

		addLinkedCardFormButton: function () {
			this.link_card_button = new ButtonComponent({
				// General
				elementName: '.js-linked-account-add-form-button-container',
				calling_view: this,
				// Transactional
				is_transaction: false,
				// Default
				btn_label: 'Save',
				btn_callback: this.saveNewCard,
				// Confirm
				btn_confirm: false,
				// Cancel
				btn_cancel: true,
				btn_cancel_label: 'Cancel',
				btn_cancel_callback: this.clearLinkedCardForm,
				// Success Modal
				btn_success_modal: true,
				btn_success_modal_delay: 3000,
				btn_success_modal_header: 'Card Successfully Linked',
				btn_success_modal_label: 'OK',
				btn_success_modal_message:
					'Your card will be able to earn rewards in approximately 1 hour.',
				btn_success_modal_callback: this.saveNewCardSuccess,
				// Error Modal
				btn_error_modal: true,
				btn_error_modal_delay: 300,
				btn_error_modal_header: 'Card Not Linked',
				btn_error_modal_label: 'OK',
				btn_error_modal_message:
					'There was a problem linking your card. Try again later.',
				btn_error_modal_callback: this.saveNewCardError,
			});
		},

		saveNewCardSuccess: function (resetButtons) {
			var that = that ? that : this;

			if (resetButtons.name) {
				that.link_card_button[resetButtons.name]();
			} else {
				resetButtons(that.link_card_button);
			}
		},

		saveNewCardError: function (resetButtons, that) {
			var that = that ? that : this;

			if (resetButtons.name) {
				that.link_card_button[resetButtons.name]();
			} else {
				resetButtons(that.link_card_button);
			}
		},

		saveNewCard: function (processComplete, that) {
			var that = that ? that : this,
				form_is_valid = true,
				card_number = that.validateCardNumber(),
				exp_date = that.validateExpDate(),
				zip_code = that.validateZipcode(),
				nickname = that.validateCardNickname(),
				cvv = that.validateCvv(),
				pf_terms = that.validateAccountHolderTerms();

			if (that.card_type == enums.networkSources.Visa) {
				var card_terms = that.validateVisaTerms();
			} else if (that.card_type == enums.networkSources.MasterCard) {
				var card_terms = that.validateMastercardTerms();
			} else {
				var card_terms = false;
			}

			if (!card_number.isValid()) {
				form_is_valid = false;
			}

			if (!exp_date.dateIsValid) {
				form_is_valid = false;
			}

			if (!cvv) {
				form_is_valid = false;
			}

			if (!zip_code.isValid()) {
				form_is_valid = false;
			}

			if (!nickname.isValid() && !nickname.isEmpty()) {
				form_is_valid = false;
			}

			if (!pf_terms) {
				form_is_valid = false;
			}

			if (!card_terms) {
				form_is_valid = false;
			}

			if (form_is_valid) {
				that.link_card.form_invalid = false;

				var body = {
					origin: window.location.href,
					userGUID: pf.session.get('UserGUID'),
					data: {
						cardNum: encrypt(card_number.get('value')),
						expYear: '20' + exp_date.yearValidator.get('value'),
						expMonth: exp_date.monthValidator.get('value'),
						cvv: encrypt(cvv),
						nickname: nickname.get('value'),
						billingZip: zip_code.get('value'),
						agreeTOS: card_terms,
						agreePFAgreement: pf_terms,
					},
				};

				var secure_content = new SecureContent({ requestBody: body });
				return secure_content.postContent(function (error, body) {
					that.postContentCallback(error, body, that, processComplete);
				});
			} else {
				that.link_card.form_invalid = true;

				that.updateCardFormError();

				if (processComplete.name) {
					that.link_card_button[processComplete.name](false);
				} else {
					processComplete(false, that.link_card_button);
				}
			}
		},

		postContentCallback: function (error, body, that, processComplete) {
			// console.log('postContentCallback',that,error,body);
			if (error != null || error != undefined) {
				if (error.status == 409) {
					that.link_card_button.updateErrorModalMessage(
						'This card is already registered.'
					);
				}

				if (processComplete.name) {
					that.link_card_button[processComplete.name](false);
				} else {
					processComplete(false, that.link_card_button);
				}
			} else {
				if (processComplete.name) {
					that.link_card_button[processComplete.name](true);
				} else {
					processComplete(true, that.link_card_button);
				}

				that.clearLinkedCardForm(that, true);
				that.hideLinkCardForm();
				// Clear the linked cards list and re-load
				$('.js-linked-accounts-cards').html('');
				that.getLinkedCards();
			}
		},

		showLinkCardForm: function (e) {
			if (isSunsetting()) {
				e.preventDefault();
				return;
			}

			if (pf.IsConsumerFinancial) {
				this.$('.js-link-card-btn').hide();
				this.$('.js-linked-accounts-add-card-container').show();
			} else {
				goToFinancialRegistration('linkedaccounts');
			}
		},

		hideLinkCardForm: function (e) {
			if (e && e.preventDefault) {
				e.preventDefault();
			}
			if (e && e.stopPropagation) {
				e.stopPropagation();
			}

			this.$el.find('.js-linked-accounts-add-card-container').hide();
			this.$el.find('.js-link-card-btn').show();
		},

		clearLinkedCardForm: function (that, response) {
			var that = that ? that : this;

			that.$('.js-card-number').val('');
			that.$('.js-card-exp').val('');
			that.$('.js-card-cvc').val('');
			that.$('.js-card-zip').val('');

			that.$('.js-add-card-nickname').val('');
			that.$('.js-add-card-nickname-feedback').val('');
			that.$('.js-add-card-accountholder').prop('checked', false);
			that.$('.js-add-card-accountholder-feedback').val('');
			that.$('.js-add-card-visa').prop('checked', false);
			that.$('.js-add-card-visa-feedback').val('');
			that.$('.js-add-card-mastercard').prop('checked', false);
			that.$('.js-add-card-mastercard-feedback').val('');

			that.resetLinkCardForm();

			if (!response) {
				that.hideLinkCardForm();
			}
		},

		resetLinkCardForm: function () {
			this.$('.js-form-creditcard').removeClass('error');
			this.$('.js-card-feedback').html('');

			this.link_card = {
				form_active: false,
				form_invalid: false,
				credit_card: {
					number: {
						valid: null,
						value: null,
						empty: true,
						active: false,
						touched: false,
						complete: false,
					},
					exp: {
						valid: null,
						value: null,
						empty: true,
						active: false,
						touched: false,
						complete: false,
					},
					cvv: {
						valid: null,
						value: null,
						empty: true,
						active: false,
						touched: false,
						complete: false,
					},
					zip: {
						valid: null,
						value: null,
						empty: true,
						active: false,
						touched: false,
						complete: false,
					},
				},
			};
		},

		getKeyCodeNumber: function (keycode) {
			var number = '';

			switch (keycode) {
				case 48:
					number = '0';
					break;
				case 49:
					number = '1';
					break;
				case 50:
					number = '2';
					break;
				case 51:
					number = '3';
					break;
				case 52:
					number = '4';
					break;
				case 53:
					number = '5';
					break;
				case 54:
					number = '6';
					break;
				case 55:
					number = '7';
					break;
				case 56:
					number = '8';
					break;
				case 57:
					number = '9';
					break;
				default:
					number = false;
					break;
			}

			return number;
		},

		/*
            Card Form Focus Events
        */

		cardNumberFormFocus: function () {
			this.link_card.credit_card.number.touched = true;
			this.link_card.credit_card.number.active = true;

			this.updateLinkedCardFormState();
		},
		cardExpFormFocus: function () {
			this.link_card.credit_card.exp.touched = true;
			this.link_card.credit_card.exp.active = true;

			this.updateLinkedCardFormState();
		},
		cardCVVFormFocus: function () {
			this.link_card.credit_card.cvv.touched = true;
			this.link_card.credit_card.cvv.active = true;

			this.updateLinkedCardFormState();
		},
		cardZipFormFocus: function () {
			this.link_card.credit_card.zip.touched = true;
			this.link_card.credit_card.zip.active = true;

			this.updateLinkedCardFormState();
		},

		/*
            Card Form Blur Events
        */

		cardNumberFormBlur: function () {
			var that = this;

			this.link_card.credit_card.number.active = false;

			this.validateCardNumber();

			setTimeout(function () {
				that.updateLinkedCardFormState();
			}, 300);
		},
		cardExpFormBlur: function () {
			var that = this;

			this.link_card.credit_card.exp.active = false;

			this.validateExpDate();

			setTimeout(function () {
				that.updateLinkedCardFormState();
			}, 300);
		},
		cardCVVFormBlur: function () {
			var that = this;

			this.link_card.credit_card.cvv.active = false;

			this.validateCvv();

			setTimeout(function () {
				that.updateLinkedCardFormState();
			}, 300);
		},
		cardZipFormBlur: function () {
			var that = this;

			this.link_card.credit_card.zip.active = false;

			this.validateZipcode();

			setTimeout(function () {
				that.updateLinkedCardFormState();
			}, 300);
		},

		updateLinkedCardFormState: function () {
			var link_card_form = this.link_card.credit_card,
				cc_number = link_card_form.number,
				cc_exp = link_card_form.exp,
				cc_cvv = link_card_form.cvv,
				cc_zip = link_card_form.zip;

			// console.log('updateLinkedCardFormState', (!cc_number.active && !cc_exp.active && !cc_cvv.active && !cc_zip.active), !this.link_card.form_active);

			if (
				!cc_number.active &&
				!cc_exp.active &&
				!cc_cvv.active &&
				!cc_zip.active
			) {
				this.link_card.form_active = false;
				this.deactivateCardForm();
			} else if (!this.link_card.form_active) {
				this.link_card.form_active = true;
				this.activateCardForm();
			}
		},

		activateCardForm: function () {
			this.$el.find('.js-form-creditcard').addClass('active');
		},

		deactivateCardForm: function () {
			this.$el.find('.js-form-creditcard').removeClass('active');
		},

		updateCardFormError: function () {
			var form_error = false,
				error_message = null,
				link_card_form = this.link_card.credit_card,
				cc_number = link_card_form.number,
				cc_exp = link_card_form.exp,
				cc_cvv = link_card_form.cvv,
				cc_zip = link_card_form.zip;

			// Card Zipcode
			if (
				(cc_zip.valid == false && cc_zip.complete && cc_zip.touched) ||
				(cc_zip.touched && !cc_zip.complete && !cc_zip.valid && !cc_zip.empty)
			) {
				form_error = true;
				this.$('.js-card-zip').addClass('error');
				error_message = pf.content.validation.zipCode.invalid;
			} else if (
				cc_zip.valid == true ||
				(!cc_zip.valid &&
					!cc_zip.complete &&
					cc_zip.touched &&
					cc_zip.active) ||
				cc_zip.empty
			) {
				this.$('.js-card-zip').removeClass('error');
			}

			// Card CVV
			if (
				(cc_cvv.valid == false && cc_cvv.complete && cc_cvv.touched) ||
				(cc_cvv.touched && !cc_cvv.complete && !cc_cvv.valid && !cc_cvv.empty)
			) {
				form_error = true;
				this.$('.js-card-cvc').addClass('error');
				error_message = 'Enter 3 digit CVV';
			} else if (
				cc_cvv.valid == true ||
				(!cc_cvv.valid &&
					!cc_cvv.complete &&
					cc_cvv.touched &&
					cc_cvv.active) ||
				cc_cvv.empty
			) {
				this.$('.js-card-cvc').removeClass('error');
			}

			// Card Expiration
			if (
				(cc_exp.valid == false && cc_exp.complete && cc_exp.touched) ||
				(cc_exp.touched && !cc_exp.complete && !cc_exp.valid && !cc_exp.empty)
			) {
				form_error = true;
				this.$('.js-card-exp').addClass('error');
				error_message = 'Enter a valid month and year';
			} else if (
				cc_exp.valid == true ||
				(!cc_exp.valid &&
					!cc_exp.complete &&
					cc_exp.touched &&
					cc_exp.active) ||
				cc_exp.empty
			) {
				this.$('.js-card-exp').removeClass('error');
			}

			// Card Number
			if (
				(cc_number.valid == false && cc_number.complete && cc_number.touched) ||
				(cc_number.touched &&
					!cc_number.complete &&
					!cc_number.valid &&
					!cc_number.empty)
			) {
				form_error = true;
				this.$('.js-card-number').addClass('error');
				error_message = 'Enter a valid card number';
			} else if (
				cc_number.valid == true ||
				(!cc_number.valid &&
					!cc_number.complete &&
					cc_number.touched &&
					cc_number.active) ||
				cc_number.empty
			) {
				this.$('.js-card-number').removeClass('error');
			}

			if (form_error) {
				this.$('.js-form-creditcard').addClass('error');
				this.$('.js-card-feedback').html(error_message);
			} else {
				this.$('.js-form-creditcard').removeClass('error');
				this.$('.js-card-feedback').html('');
			}
		},

		validateCardNumber: function () {
			var input = this.$('.js-card-number'),
				input_value = this.link_card.credit_card.number.value
					? this.link_card.credit_card.number.value
					: '',
				validator = new LinkedCardValidator();

			validator.validate(input_value);

			if (validator.isValid()) {
				this.link_card.credit_card.number.valid = true;
			} else {
				this.link_card.credit_card.number.valid = false;
			}

			this.updateCardFormError();

			return validator;
		},

		keyupValidateCardNumber: function (e) {
			var val = $(e.target).val(),
				true_value = val.split(' ').join(''),
				new_value = true_value.replace(/(.{4})/g, '$1 '),
				len = true_value.length;

			this.link_card.credit_card.number.value = true_value;
			this.link_card.credit_card.number.empty = false;

			// Validate and format card number
			if (len == 16) {
				this.link_card.credit_card.number.complete = true;

				$(e.target).val(new_value);

				this.validateCardNumber();

				this.$el.find('.js-card-exp').focus();
			} else if (len == 0) {
				this.link_card.credit_card.number.empty = true;
				this.link_card.credit_card.number.complete = false;
				this.validateCardNumber();
			}

			var brand = this.getCardType(e);
			this.updateCardTerms(brand);

			return false;
		},

		keydownValidateCardNumber: function (e) {
			switch (true) {
				case e.keyCode >= 48 && e.keyCode <= 57: // Numbers
				case e.keyCode >= 96 && e.keyCode <= 105: // Numberpad
				case e.keyCode == 37: // Left Arrow
				case e.keyCode == 39: // Right Arrow
				case e.keyCode == 8: // Backspace
				case e.keyCode == 46: // Delete
				case e.keyCode == 32: // Space
				case e.keyCode == 9: // Tab
				case e.keyCode == 91: // Command
				case e.keyCode == 16: // Shift
				case e.keyCode == 17: // Control
				case e.keyCode == 18: // Control
				case e.keyCode == 86: // V Character
				case e.keyCode == 82: // R Character
					this.link_card.credit_card.number.touched = true;
					this.formatCardNumber(e);
					// console.log('keydownValidateCardNumber',e.keyCode, this);
					break;
				default:
					return false;
					break;
			}
		},

		formatCardNumber: function (e) {
			var val = $(e.target).val(),
				true_value = val.split(' ').join(''),
				new_value = true_value.replace(/(.{4})/g, '$1 '),
				len = true_value.length,
				next_number = this.getKeyCodeNumber(e.keyCode);

			switch (len) {
				case 0:
					this.link_card.credit_card.number.complete = false;
					break;
				case 4:
					if (next_number) {
						$(e.target).val(new_value);
					}
					break;
				case 8:
					if (next_number) {
						$(e.target).val(new_value);
					}
					break;
				case 12:
					if (next_number) {
						$(e.target).val(new_value);
					}
					break;
			}
		},

		getCardType: function (e) {
			var val = $(e.target).val(),
				true_value = val.split(' ').join(''),
				brand = false;

			switch (true) {
				case true_value.indexOf('4') == 0:
				case true_value.indexOf('4026') >= 0:
				case true_value.indexOf('4405') >= 0:
				case true_value.indexOf('4508') >= 0:
				case true_value.indexOf('4844') >= 0:
				case true_value.indexOf('4913') >= 0:
				case true_value.indexOf('4917') >= 0:
				case true_value.indexOf('417500') >= 0:
					brand = enums.networkSources.Visa;
					break;
				case true_value.indexOf('50') >= 0:
				case true_value.indexOf('51') >= 0:
				case true_value.indexOf('52') >= 0:
				case true_value.indexOf('53') >= 0:
				case true_value.indexOf('54') >= 0:
				case true_value.indexOf('55') >= 0:
					brand = enums.networkSources.MasterCard;
					break;
			}

			this.card_type = brand;

			return brand;
		},

		updateCardTerms: function (card_type) {
			switch (card_type) {
				case enums.networkSources.Visa:
					this.$('.js-blank-cc').removeClass('active');
					this.$('.js-mastercard-logo').removeClass('active');
					this.$('.form-checkbox.mastercard').hide();

					this.$('.form-checkbox.visa').show();
					this.$('.js-visa-logo').addClass('active');
					break;
				case enums.networkSources.MasterCard:
					this.$('.js-blank-cc').removeClass('active');
					this.$('.js-visa-logo').removeClass('active');
					this.$('.form-checkbox.visa').hide();

					this.$('.js-mastercard-logo').addClass('active');
					this.$('.form-checkbox.mastercard').show();
					break;
				default:
					this.$('.js-mastercard-logo').removeClass('active');
					this.$('.js-visa-logo').removeClass('active');
					this.$('.form-checkbox.mastercard').hide();
					this.$('.form-checkbox.visa').hide();

					this.$('.js-blank-cc').addClass('active');
					break;
			}
		},

		validateExpDate: function () {
			var input_value = this.link_card.credit_card.exp.value
					? this.link_card.credit_card.exp.value
					: '',
				month = input_value.slice(0, 2),
				year = input_value.slice(2),
				month_validator = new MonthValidator(),
				year_validator = new YearValidator();

			// console.log('validateExpDate',input_value,input_value.length);

			if (input_value.length <= 4) {
				month_validator.validate(month);
				year_validator.validate(year);

				var month = month_validator.getIntValue(),
					year = year_validator.getIntValue(),
					now = new Date(),
					card_date = new Date(),
					later_date = true;

				var month_is_valid;
				if (!month_validator.isValid()) {
					// styleInputError(month);
					month_is_valid = false;
				} else if (year == now.getFullYear() && month < now.getMonth() + 1) {
					// Date chosen is in the current year, but in the past, thus invalid
					// styleInputError(month);
					month_is_valid = false;
				} else {
					// Valid
					// styleInputValid(month);
					month_is_valid = true;
				}

				var year_is_valid;
				if (!year_validator.isValid()) {
					// styleInputError(year);
					year_is_valid = false;
				} else {
					// Valid
					// styleInputValid(year);
					year_is_valid = true;
				}

				card_date.setFullYear('20' + year.toString(), month.toString(), 1);

				if (card_date < now) {
					later_date = false;
				}

				var is_valid = month_is_valid && year_is_valid; // BOOLEAN
				// Only add error message if both Month and Year have been interacted with.
				if (!is_valid || !later_date) {
					this.link_card.credit_card.exp.valid = false;
				} else {
					this.link_card.credit_card.exp.valid = true;
				}
			} else {
				this.link_card.credit_card.exp.valid = false;
			}

			this.updateCardFormError();

			var result = {
				monthValidator: month_validator,
				yearValidator: year_validator,
				dateIsValid: is_valid,
			};
			return result;
		},

		keyupValidateExp: function (e) {
			var val = $(e.target).val(),
				true_value = val.split(' ').join('').replace('/', ''),
				len = true_value.length;

			this.link_card.credit_card.exp.value = true_value;

			if (len == 1 && true_value && true_value != '0' && true_value != '1') {
				var new_true_value = '0' + true_value;
				var combined_value = new_true_value.replace(/(.{2})/g, '$1/');
				$(e.target).val(combined_value);

				this.link_card.credit_card.exp.empty = false;
			} else if (len == 2 && e.keyCode != 46 && e.keyCode != 8) {
				var new_value = true_value.replace(/(.{2})/g, '$1/');
				$(e.target).val(new_value);

				this.link_card.credit_card.exp.empty = false;
			}

			// Validate and format card number
			if (len == 4 || len == 0) {
				if (len == 4) {
					this.link_card.credit_card.exp.complete = true;
					this.link_card.credit_card.exp.empty = false;
					this.$el.find('.js-card-cvc').focus();
				} else {
					this.link_card.credit_card.exp.empty = true;
				}

				this.validateExpDate();
			}

			return false;
		},

		keydownValidateExp: function (e) {
			switch (true) {
				case e.keyCode >= 48 && e.keyCode <= 57: // Numbers
				case e.keyCode >= 96 && e.keyCode <= 105: // Numberpad
				case e.keyCode == 37: // Left Arrow
				case e.keyCode == 39: // Right Arrow
				case e.keyCode == 8: // Backspace
				case e.keyCode == 46: // Delete
				case e.keyCode == 32: // Space
				case e.keyCode == 9: // Tab
				case e.keyCode == 191: // Forward Slash
				case e.keyCode == 111: // Forward Slash
				case e.keyCode == 91: // Command
				case e.keyCode == 16: // Shift
				case e.keyCode == 17: // Control
				case e.keyCode == 18: // Control
				case e.keyCode == 86: // V Character
				case e.keyCode == 82: // R Character
					this.link_card.credit_card.exp.touched = true;
					this.formatExp(e);
					// console.log('keydownValidateExp',e.keyCode, this);
					break;
				default:
					return false;
					break;
			}
		},

		formatExp: function (e) {
			var val = $(e.target).val(),
				true_value = val.split(' ').join('').replace('/', ''),
				new_value = true_value.replace(/(.{2})/g, '$1/'),
				len = true_value.length,
				next_number = this.getKeyCodeNumber(e.keyCode);

			this.link_card.credit_card.exp.complete = false;

			if (len == 1 && next_number) {
				$(e.target).val(new_value);
			} else if (len == 0) {
				this.link_card.credit_card.exp.empty = true;
				this.validateExpDate();
			}
		},

		validateCvv: function () {
			var input_value = this.link_card.credit_card.cvv.value;

			if (input_value && input_value.length == 3) {
				this.link_card.credit_card.cvv.valid = true;
				this.updateCardFormError();
				return input_value;
			} else {
				this.link_card.credit_card.cvv.valid = false;
				this.updateCardFormError();
				return false;
			}
		},

		keyupValidateCvc: function (e) {
			var val = $(e.target).val(),
				true_value = val.split(' ').join('').replace('/', ''),
				len = true_value.length;

			this.link_card.credit_card.cvv.value = true_value;
			this.link_card.credit_card.cvv.empty = false;

			// Validate and format card number
			if (len == 3) {
				this.link_card.credit_card.cvv.complete = true;

				this.$el.find('.js-card-zip').focus();
			} else if (len == 0) {
				this.link_card.credit_card.cvv.empty = true;
				this.link_card.credit_card.cvv.touched = false;
				this.validateCvv();
			}

			return false;
		},

		keydownValidateCvc: function (e) {
			switch (true) {
				case e.keyCode >= 48 && e.keyCode <= 57: // Numbers
				case e.keyCode >= 96 && e.keyCode <= 105: // Numberpad
				case e.keyCode == 37: // Left Arrow
				case e.keyCode == 39: // Right Arrow
				case e.keyCode == 8: // Backspace
				case e.keyCode == 46: // Delete
				case e.keyCode == 9: // Tab
				case e.keyCode == 91: // Command
				case e.keyCode == 16: // Shift
				case e.keyCode == 17: // Control
				case e.keyCode == 18: // Control
				case e.keyCode == 86: // V Character
				case e.keyCode == 82: // R Character
					this.link_card.credit_card.cvv.touched = true;
					this.formatCvc(e);
					// console.log('keydownValidateZip',e.keyCode, this);
					break;
				default:
					return false;
					break;
			}
		},

		formatCvc: function (e) {
			var val = $(e.target).val(),
				true_value = val.split(' ').join('').replace('/', ''),
				len = true_value.length,
				next_number = this.getKeyCodeNumber(e.keyCode);

			if (len <= 3) {
				$(e.target).val(true_value);
			}
		},

		validateZipcode: function () {
			var input_value = this.link_card.credit_card.zip.value,
				validator = new ZipcodeValidator({ lookup: false });

			validator.validate(input_value);

			if (validator.isValid()) {
				this.link_card.credit_card.zip.valid = true;
			} else {
				this.link_card.credit_card.zip.valid = false;
			}

			this.updateCardFormError();

			return validator;
		},

		keyupValidateZip: function (e) {
			var val = $(e.target).val(),
				true_value = val.split(' ').join('').replace('/', ''),
				len = true_value.length;

			this.link_card.credit_card.zip.value = true_value;
			this.link_card.credit_card.zip.empty = false;

			// Validate and format card number
			if (len == 5) {
				this.link_card.credit_card.cvv.complete = true;

				this.$el.find('.js-add-card-nickname').focus();
			} else if (len == 0) {
				this.link_card.credit_card.zip.empty = true;
				this.link_card.credit_card.cvv.complete == false;
				this.validateZipcode();
			}

			return false;
		},

		keydownValidateZip: function (e) {
			switch (true) {
				case e.keyCode >= 48 && e.keyCode <= 57: // Numbers
				case e.keyCode >= 96 && e.keyCode <= 105: // Numberpad
				case e.keyCode == 37: // Left Arrow
				case e.keyCode == 39: // Right Arrow
				case e.keyCode == 8: // Backspace
				case e.keyCode == 46: // Delete
				case e.keyCode == 9: // Tab
				case e.keyCode == 91: // Command
				case e.keyCode == 16: // Shift
				case e.keyCode == 17: // Control
				case e.keyCode == 18: // Control
				case e.keyCode == 86: // V Character
				case e.keyCode == 82: // R Character
					this.link_card.credit_card.zip.touched = true;
					this.formatZip(e);
					// console.log('keydownValidateZip',e.keyCode, this);
					break;
				default:
					return false;
					break;
			}
		},

		formatZip: function (e) {
			var val = $(e.target).val(),
				true_value = val.split(' ').join('').replace('/', ''),
				len = true_value.length,
				next_number = this.getKeyCodeNumber(e.keyCode);

			if (len <= 5) {
				$(e.target).val(true_value);
			}
		},

		validateCardNickname: function () {
			var input = this.$('.js-add-card-nickname'),
				input_feedback = this.$('.js-add-card-nickname-feedback'),
				validator = new LinkedCardNicknameValidator();

			validator.validate(input.val().trim());

			if (validator.isEmpty()) {
				feedbackClear(input, input_feedback);
			} else if (validator.isValid()) {
				feedbackValid(input, input_feedback);
			} else {
				feedbackError(
					input,
					input_feedback,
					pf.content.validation.cardNicknameLinked
				);
			}
			return validator;
		},

		validateAccountHolderTerms: function () {
			var input = this.$('.js-add-card-accountholder'),
				input_feedback = this.$('.js-add-card-accountholder-feedback'),
				isValid = true;

			if (input.prop('checked')) {
				feedbackValid(input, input_feedback);
			} else {
				isValid = false;
				feedbackError(
					input,
					input_feedback,
					pf.content.validation.acceptAccountHolderAgreement
				);
			}
			return isValid;
		},

		validateMastercardTerms: function () {
			var input = this.$('.js-add-card-mastercard'),
				input_feedback = this.$('.js-add-card-mastercard-feedback'),
				isValid = true;

			if (input.is(':checked')) {
				feedbackValid(input, input_feedback);
			} else {
				feedbackError(
					input,
					input_feedback,
					pf.content.validation.acceptCardTerms
				);
				isValid = false;
			}
			return isValid;
		},

		validateVisaTerms: function () {
			var input = this.$('.js-add-card-visa'),
				input_feedback = this.$('.js-add-card-visa-feedback'),
				isValid = true;

			if (input.is(':checked')) {
				feedbackValid(input, input_feedback);
			} else {
				feedbackError(
					input,
					input_feedback,
					pf.content.validation.acceptCardTerms
				);
				isValid = false;
			}
			return isValid;
		},

		addExpYearsToLinkedCardForm: function () {
			var this_year = new Date().getFullYear();

			for (var i = 0; i < 20; i++) {
				var year_option = this_year + i;
				this.$('.js-add-card-date-year').append(
					this.createSelectOption(year_option, year_option)
				);
			}
		},

		createSelectOption: function (val, content) {
			var option = '<option value="{val}">$ {content}</option>';
			return option.replace('{val}', val).replace('{content}', content);
		},

		getLinkedCards: function () {
			var that = this;

			this.linked_cards = new LinkedCardsModel({
				instanceURL: pf.consumerURL + '/LinkedCards?smc=true',
			});
			this.linked_cards.fetch({
				success: function (model, resp) {
					that.$('.js-linked-accounts-cards-container').find('.spinner').hide();

					if (that.linked_cards.length) {
						that.listCards();
					}
				},
				error: function () {
					// TODO: Empy error state
				},
			});
		},

		listCards: function () {
			var that = this,
				cards = this.linked_cards.toJSON();

			this.linked_card_views = [];

			// Ensure the list isn't already populated.  This typically happens after financial session expires upon re-login.
			if ($('.js-linked-accounts-cards').is(':empty')) {
				cards.forEach(function (card) {
					that.addCard(card);
				});
			}
		},

		addCard: function (card) {
			$('.js-edit-linked-account').append('');
			var card_view = new LinkedCardView({
				data: card,
				card_view: this,
				card_id: 'card-' + card.Identifier,
			});
			this.linked_card_views.push(card_view);
			$('.js-linked-accounts-cards').append(card_view.el);
		},

		closeAllCardForms: function (current_card_guid) {
			for (var i = 0; i < this.linked_card_views.length; i++) {
				var linked_card = this.linked_card_views[i];

				if (
					linked_card.is_open &&
					linked_card.data.LinkedCardGUID != current_card_guid
				) {
					linked_card.closeEditForm({ render: false });
				}
			}
		},

		showLinkBankForm: function () {
			if (pf.IsConsumerFinancial) {
				this.$el.find('.js-linked-accounts-add-bank-container').show();
				this.$el.find('.js-link-bank-btn').hide();

				// Add create Bank button
				this.addCreateBankButton();
			} else {
				goToFinancialRegistration('linkedaccounts');
			}
		},

		hideLinkBankForm: function (e) {
			if (e && e.preventDefault) {
				e.preventDefault();
			}
			if (e && e.stopPropagation) {
				e.stopPropagation();
			}

			this.$el.find('.js-linked-accounts-add-bank-container').hide();
			this.$el.find('.js-link-bank-btn').show();
		},

		getBank: function () {
			var that = this;

			this.bank = new BankModel();
			this.bank.fetch({
				success: function (model, resp) {
					var bank = that.bank.toJSON();

					// Temporary
					// that.addReloadButton();
					// that.showBankEmptyState();

					that.$('.js-linked-accounts-bank-container').find('.spinner').hide();

					if (!_.isEmpty(bank)) {
						that.showBankInfo();
					} else {
						that.showBankEmptyState();
					}
				},
				error: function (err, a) {
					// console.log('getBankStatus error',err,a);
					// TODO: Show error state
					that.showBankEmptyState();
				},
			});
		},

		showBankInfo: function () {
			var bank = this.bank.toJSON();

			if (bank.is_verifiable) {
				this.is_verifiable = true;
			}

			if (_.isString(bank.account_number) || _.isNumber(bank.account_number)) {
				var account_number = bank.account_number.toString(),
					last4 =
						account_number.length > 4
							? account_number.slice(account_number.length - 4)
							: account_number;

				this.bank_account_last4 = last4;
			}

			if (
				bank.verification_status == 'undefined' ||
				bank.verification_status == '0' ||
				bank.verification_status == 0
			) {
				/* No linked bank account */
				this.showBankEmptyState();
			} else if (
				bank.verification_status != '2' ||
				bank.verification_status != 2
			) {
				/* Has linked bank account but hasn't verified, if it is equal to 2 then the bank account has been verified */
				this.showUnverifiedBank();
			} else {
				this.showBankAccount();
			}
		},

		showBankEmptyState: function () {
			// Hide Bank Account Area
			this.$el.find('.js-linked-accounts-bank').hide();

			// Show Link Bank Account Button
			this.$el.find('.js-link-bank-btn').show();
		},

		showUnverifiedBank: function () {
			var bank = this.bank.toJSON();

			// Action Buttons
			this.$el.find('.js-linked-accounts-bank-edit').hide();
			this.$el.find('.js-linked-accounts-bank-remove').hide();
			this.$el.find('.js-linked-accounts-bank-verify').show();

			// Hide Link Bank Button
			this.$el.find('.js-link-bank-btn').hide();

			// Show Bank Account Area and Name
			this.$el.find('.js-linked-accounts-bank').show();
			this.$el.find('.js-linked-accounts-bank-name').html(bank.account_name);
		},

		addCreateBankButton: function () {
			this.create_bank_button = new ButtonComponent({
				// General
				elementName: '.js-linked-account-add-bank-buttons-container',
				calling_view: this,
				// Transactional
				is_transaction: false,
				// Default
				btn_label: 'Link Bank Account',
				btn_callback: this.verifyNewBank,
				// Confirm
				btn_confirm: true,
				btn_confirm_label: 'Confirm',
				btn_confirm_callback: this.saveNewBank,
				// Cancel
				btn_cancel: true,
				btn_cancel_label: 'Cancel',
				btn_cancel_callback: this.cancelSaveNewBank,
				// Success Modal
				btn_success_modal: true,
				btn_success_modal_delay: 3000,
				btn_success_modal_header: "You're almost done!",
				btn_success_modal_label: 'OK',
				btn_success_modal_message:
					'Within 2-4 days, two small deposits from PayForward will appear in your bank account ending in 1234. When you see them, come back here to verify your account.',
				btn_success_modal_callback: this.saveNewBankSuccess,
				// Error
				btn_error: true,
				btn_error_delay: 700,
				btn_error_label: 'Retry',
				btn_error_cancel_label: 'Cancel',
				btn_error_message: 'Could not verify bank account',
				btn_error_callback: this.canceledSaveNewBankOnError,
			});
		},

		clearBankForm: function () {
			this.$('.js-add-bank-routing-number').val(''),
				this.$('.js-add-bank-account-number').val(''),
				this.$('.js-add-bank-nickname-number').val('');
		},

		saveNewBankSuccess: function (resetButtonState) {
			var that = that ? that : this;
			// Clear and hide form
			that.clearBankForm();
			that.$('.js-linked-accounts-add-bank-container').hide();
			// that.$('.js-linked-accounts-bank').show();

			// Show bank unverified state
			that.getBank();
		},

		cancelSaveNewBank: function (that) {
			var that = that ? that : this;

			// Clear and hide form
			that.clearBankForm();
			that.$('.js-linked-accounts-add-bank-container').hide();

			// Show bank empty state
			that.showBankEmptyState();
		},

		canceledSaveNewBankOnError: function (that) {
			// console.log('canceledSaveNewBankOnError',that);
		},

		verifyNewBank: function (proceedToConfirm, that) {
			var that = that ? that : this;

			// As of now no client validation is necessary for Bank information
			if (proceedToConfirm.name) {
				that.create_bank_button[proceedToConfirm.name]();
			} else {
				proceedToConfirm(that.create_bank_button);
			}
		},

		saveNewBank: function (processComplete, that) {
			var that = that ? that : this,
				name = that.$('.js-add-bank-nickname-number'),
				account_number = that.$('.js-add-bank-account-number'),
				routing_number = that.$('.js-add-bank-routing-number');

			if (
				_.isNumber(Number(account_number.val())) &&
				Number(account_number.val()) > 0 &&
				_.isNumber(Number(routing_number.val())) &&
				Number(routing_number.val()) > 0
			) {
				that.link_bank_model = new LinkBankModel({
					instanceURL: pf.consumerURL + '/LinkBankAccount',
				});

				that.link_bank_model.set({
					BankName: name.val(),
					BankAccountNumber: account_number.val(),
					BankRoutingNumber: routing_number.val(),
				});

				that.link_bank_model.save(null, {
					success: function (model, resp) {
						if (resp.Success) {
							that.bank_account_last4 = account_number
								.val()
								.slice(account_number.val().length - 4);

							that.create_bank_button.updateSuccessModalMessage(
								'Within 2-4 days, two small deposits from PayForward will appear in your bank account ending in ' +
									that.bank_account_last4 +
									'. When you see them, come back here to verify your account.'
							);

							if (processComplete.name) {
								that.create_bank_button[processComplete.name](true);
							} else {
								processComplete(true, that.create_bank_button);
							}
						} else {
							that.create_bank_button.updateErrorMessage(
								'We are unable to process your request, please contact Member Services: <a href="tel:8449449273">844-944-9273</a>'
							);

							if (processComplete.name) {
								that.create_bank_button[processComplete.name](false);
							} else {
								processComplete(false, that.create_bank_button);
							}
						}
					},
					error: function (model, resp) {
						switch (resp.status) {
							case 400:
								var msg = jQuery.parseJSON(resp.responseText);
								if (msg) {
									that.create_bank_button.updateErrorMessage(msg.Message);
								} else {
									that.create_bank_button.updateErrorMessage(
										'Please try again'
									);
								}

								if (processComplete.name) {
									that.create_bank_button[processComplete.name](false);
								} else {
									processComplete(false, that.create_bank_button);
								}
								break;
							case 401:
								that.create_bank_button.updateErrorMessage('Please try again');

								if (processComplete.name) {
									that.create_bank_button[processComplete.name](false);
								} else {
									processComplete(false, that.create_bank_button);
								}
								break;
							default:
								that.create_bank_button.updateErrorMessage(
									'We are unable to process your request, please contact Member Services: <a href="tel:8449449273">844-944-9273</a>'
								);

								if (processComplete.name) {
									that.create_bank_button[processComplete.name](false);
								} else {
									processComplete(false, that.create_bank_button);
								}
								break;
						}
					},
				});
			} else {
				that.create_bank_button.updateErrorMessage(
					'Add a valid Routing and Account number'
				);

				if (processComplete.name) {
					that.create_bank_button[processComplete.name](false);
				} else {
					processComplete(false, that.create_bank_button);
				}
			}
		},

		successModalCallbackMODAL: function () {
			// console.log('successModalCallbackMODAL');
		},

		deleteBankAccountMODAL: function () {
			this.removeBank();
		},

		showVerifyBankForm: function (e) {
			if (e && e.preventDefault) {
				e.preventDefault();
			}
			if (e && e.stopPropagation) {
				e.stopPropagation();
			}

			if (!this.is_verifiable) {
				var data = {
						btn_success_modal_header: "You're almost done!",
						btn_success_modal_message:
							'Within 2-4 days, two small deposits from PayForward will appear in your bank account ending in ' +
							this.bank_account_last4 +
							'. When you see them, come back here to verify your account.',
						btn_success_modal_label: 'OK',
						// Cancel Modal
						btn_cancel_modal: true,
						btn_cancel_modal_label: 'Delete Bank Account',
						btn_cancel_modal_callback: this.deleteBankAccountMODAL,
					},
					btn_success_modal_view = new ButtonSuccessModalView({
						data: data,
						calling_view: this,
					}),
					modal = new Modal({
						show: true,
						content: btn_success_modal_view.$el.html(),
						calling_view: btn_success_modal_view,
					});

				return false;
			}

			this.$el.find('.js-linked-accounts-bank-account').hide();
			this.$el.find('.js-linked-accounts-bank-verify-form-container').show();
			this.$el.find('.js-linked-accounts-unverified-bank-remove').show();

			this.verify_bank_button = new ButtonComponent({
				// General
				elementName: '.js-verify-bank-button-container',
				calling_view: this,
				// Transactional
				is_transaction: false,
				// Default
				btn_label: 'Verify Bank Account',
				btn_callback: this.verifyBank,
				btn_retry_callback: this.verifyBank,
				// Confirm
				btn_confirm: false,
				// Cancel
				btn_cancel: true,
				btn_cancel_label: 'Cancel',
				btn_cancel_callback: this.cancelVerifyBank,
				// Success
				btn_success: true,
				btn_success_delay: 700,
				btn_success_label: 'OK',
				btn_success_message:
					'Your bank account has been verified. You can now transfer funds.',
				btn_success_callback: this.verifyBankSuccess,
				// Error
				btn_error: true,
				btn_error_delay: 700,
				btn_error_label: 'Retry',
				btn_error_cancel_label: 'Cancel',
				btn_error_message: 'Could not verify bank account',
				btn_error_callback: this.canceledVerifyBankOnError,
			});

			return false;
		},

		showBankAccount: function () {
			var bank = this.bank.toJSON();

			// Action Buttons
			this.$el.find('.js-linked-accounts-bank-verify').hide();
			this.$el.find('.js-linked-accounts-bank-remove').hide();
			this.$el.find('.js-linked-accounts-bank-edit').show();

			// Hide Link Bank Button
			this.$el.find('.js-link-bank-btn').hide();

			// Show Bank Account Area and Name
			this.$el.find('.js-linked-accounts-bank').show();
			this.$el.find('.js-linked-accounts-bank-name').html(bank.account_name);
		},

		verifyBank: function (processComplete, that) {
			var that = that ? that : this;

			if (that.deposit_one > 0 && that.deposit_two > 0) {
				that.checkDeposits(processComplete, that);
			} else {
				that.verify_bank_button.updateErrorMessage(
					'Please enter valid deposit amounts.'
				);

				if (processComplete.name) {
					that.verify_bank_button[processComplete.name](false);
				} else {
					processComplete(false, that.verify_bank_button);
				}
			}
		},

		handleKeyupDepositOneAmount: function (e) {
			var data = keyupCurrencyHandling(e);

			this.deposit_one = data.number;
		},

		handleKeyupDepositTwoAmount: function (e) {
			var data = keyupCurrencyHandling(e);

			this.deposit_two = data.number;
		},

		handleBlurDepositOneAmount: function (e) {
			var data = blurCurrencyHandling(e);

			$(e.target).val(data.string);

			this.deposit_one = data.number;
		},

		handleBlurDepositTwoAmount: function (e) {
			var data = blurCurrencyHandling(e);

			$(e.target).val(data.string);

			this.deposit_two = data.number;
		},

		checkDeposits: function (processComplete, that) {
			var that = that ? that : this;

			if (
				that.deposit_one >= 0.01 &&
				that.deposit_two >= 0.01 &&
				that.deposit_one < 1 &&
				that.deposit_two < 1
			) {
				var data = {
					deposit1: that.deposit_one,
					deposit2: that.deposit_two,
				};

				$.ajax({
					type: 'POST',
					url: pf.consumerURL + '/VerifyDeposits',
					data: JSON.stringify(data),
					success: function (resp, model) {
						if (resp.Success) {
							if (processComplete.name) {
								that.verify_bank_button[processComplete.name](true);
							} else {
								processComplete(true, that.verify_bank_button);
							}
						} else {
							if (resp.MaxAttempt) {
								that.verify_bank_button.updateErrorMessage(
									sysText['PS']['settings']['fundingOptions']['veriFailMaxBody']
								);

								if (processComplete.name) {
									that.verify_bank_button[processComplete.name](false);
								} else {
									processComplete(false, that.verify_bank_button);
								}
							} else {
								that.verify_bank_button.updateErrorMessage(
									sysText['PS']['settings']['fundingOptions']['veriFailBody']
								);

								if (processComplete.name) {
									that.verify_bank_button[processComplete.name](false);
								} else {
									processComplete(false, that.verify_bank_button);
								}
							}
						}
					},
					error: function (resp, model) {
						// console.log('VerifyDeposits error',(resp.Message));
						// var message = (resp.Message) ? resp.Message : 'Please try again later';
						that.verify_bank_button.updateErrorMessage(
							'Please try again later'
						);

						if (processComplete.name) {
							that.verify_bank_button[processComplete.name](false);
						} else {
							processComplete(false, that.verify_bank_button);
						}
					},
				});
			} else {
				that.verify_bank_button.updateErrorMessage(
					'Please enter valid deposit amounts.'
				);
				that.verify_bank_button[processComplete.name](false);
			}
		},

		cancelVerifyBank: function (that) {
			var that = that ? that : this;

			that.clearVerifyBankForm();

			that.$el.find('.js-linked-accounts-bank-account').show();
			that.$el.find('.js-linked-accounts-bank-verify-form-container').hide();
			that.$el.find('.js-linked-accounts-unverified-bank-remove').hide();
		},

		verifyBankSuccess: function (resetButtonState, that) {
			var that = that ? that : this;
			that.showBankReloadForm();
			// that.showBankAccount();
		},

		clearVerifyBankForm: function () {},

		canceledVerifyBankOnError: function (that) {
			// console.log('canceledVerifyBankOnError');
		},

		showBankReloadForm: function (e) {
			if (e && e.preventDefault) {
				e.preventDefault();
			}
			if (e && e.stopPropagation) {
				e.stopPropagation();
			}

			this.$('.js-linked-accounts-bank-edit').hide();
			this.$('.js-linked-accounts-bank-verify').hide();
			this.$('.js-linked-accounts-bank-remove').show();

			this.cancelVerifyBank();

			//Shows the form for editing account name
			//Shows the reload container
			//Shows the form for reloading
			this.$('.js-linked-accounts-bank-verified-form-container').show();
			this.$('.js-linked-accounts-reload').show();
			this.$('.js-linked-accounts-bank-reload-form-container').show();

			this.getBankTransferDetails();

			this.getReloadData();

			this.addReloadButton();
		},

		toggleReloadBankForm: function () {
			if (this.$('.js-bank-reload').prop('checked')) {
				var that = this;

				this.showCipRerouteMessage(function (did_show) {
					if (!did_show) {
						that.$('.js-bank-reload-details').toggle();
					}
				});

				// this.getBankTransferDetails();

				this.addReloadButton();
			} else {
				// this.$('.js-reload-bank-button-container').empty();
			}
			// this.$('.js-reload-bank-button-container').toggle();
		},

		showCipRerouteMessage: function (callback) {
			this.cip_status = checkCipStatus();

			// this.cip_status = false;

			if (this.cip_status) {
				if (callback) {
					callback(false);
				}
			} else {
				this.cip_alert_modal_view = new AlertModalView({
					// General
					calling_view: this,
					alert_type: 1,
					// Transactional
					is_transaction: false,
					// Content
					alert_header: '',
					alert_message:
						'To transfer money into your PayForward account we need a little more information to verify your identity. This is a one-time process.<br /><br />Would you like to verify your identity now?',
					// Default
					btn_label: 'Verify',
					btn_color: '',
					btn_callback: this.routeToCipMODAL,
					btn_retry_callback: this.routeToCipMODAL,
					// Confirm
					btn_confirm: false,
					// Cancel
					btn_cancel: true,
					btn_cancel_label: 'Cancel',
					btn_cancel_callback: this.cancelCipRouteMODAL,
					// Success
					btn_success: true,
					btn_success_delay: 700,
					btn_success_label: 'OK',
					btn_success_message: '',
					btn_success_callback: this.routeToCipSuccess,
					// Error
					btn_error: true,
					btn_error_delay: 700,
					btn_error_label: 'Retry',
					btn_error_cancel_label: 'Cancel',
					btn_error_message: '',
					btn_error_callback: this.canceledCipRoutingOnError,
				});

				this.cip_alert_modal = new Modal({
					show: true,
					content: this.cip_alert_modal_view.$el.html(),
					calling_view: this.cip_alert_modal_view,
				});

				if (callback) {
					callback(true);
				}
			}
		},

		routeToCipMODAL: function () {
			this.cip_alert_modal.$el.fadeOut().remove();
			goToFinancialRegistration('linkedaccounts');
		},

		cancelCipRouteMODAL: function () {
			this.$('.js-bank-reload').trigger('click');
			this.cip_alert_modal.$el.fadeOut().remove();
		},

		routeToCipSuccess: function () {
			// console.log('routeToCipSuccess', this);
		},

		canceledCipRoutingOnError: function () {
			// console.log('canceledCipRoutingOnError', this);
		},

		getReloadData: function () {
			this.getReloadLimits();
		},

		addReloadButton: function () {
			this.reload_bank_button = new ButtonComponent({
				// General
				elementName: '.js-reload-bank-button-container',
				calling_view: this,
				// Transactional
				is_transaction: false,
				// Default
				btn_label: 'Save',
				btn_callback: this.reloadFromBank,
				btn_retry_callback: this.reloadFromBank,
				// Confirm
				btn_confirm: false,
				// Cancel
				btn_cancel: true,
				btn_cancel_label: 'Cancel',
				btn_cancel_callback: this.cancelReloadFromBank,
				// Success
				btn_success: true,
				btn_success_delay: 700,
				btn_success_label: 'OK',
				btn_success_message:
					"You're all set. Funds will be transferred automatically to your PayForward account.",
				btn_success_callback: this.reloadFromBankSuccess,
				// Error
				btn_error: true,
				btn_error_delay: 700,
				btn_error_label: 'Retry',
				btn_error_cancel_label: 'Cancel',
				btn_error_message: 'Auto-Reload could not be activated.',
				btn_error_callback: this.canceledReloadFromyBankOnError,
			});
		},

		getBankTransferDetails: function () {
			var that = this;

			// ACH Options were removed visually from limits view based on our conversations with Armen on 7/8/2015
			this.bank_transfer_details = new BankTransferModel({
				instanceURL: pf.consumerURL + '/GetBankTransferDetail',
			});

			this.bank_transfer_details.fetch({
				success: function (resp, model) {},
				error: function (model, resp) {},
			});
		},

		getReloadLimits: function () {
			var that = this,
				limits_loaded = 0;

			var limitsLoaded = function () {
				if (limits_loaded == 2) {
					that.getReloadDetails();
				}
			};

			this.reload_balance_limits = new LookupsModel();

			this.reload_balance_limits
				.fetch({
					url: pf.lookupsURL + '/CardLowBalanceLimits',
				})
				.done(function () {
					that.addReloadBalanceOptions();

					limits_loaded = limits_loaded + 1;

					limitsLoaded();
				});

			this.reload_amount_limits = new LookupsModel();

			this.reload_amount_limits
				.fetch({
					url: pf.lookupsURL + '/CardLoadFromBankAccLimits',
				})
				.done(function () {
					that.addReloadAmountOptions();

					limits_loaded = limits_loaded + 1;

					limitsLoaded();
				});
		},

		getReloadDetails: function () {
			var that = this;

			this.reload_details = new LookupsModel();

			this.reload_details
				.fetch({
					url: pf.userURL + '/Settings/CardLimits',
				})
				.done(function () {
					// that.showBankReloadForm();
					that.showReloadDetails();
				});
		},

		showReloadDetails: function () {
			var that = this,
				data = this.reload_details.models;

			if (data) {
				var balance = data.filter(function (model) {
					var item = model.toJSON();
					return item.ID == enums.CauseAttributeTypes.LowBalanceThresholdAmount;
				});

				var amt = data.filter(function (model) {
					var item = model.toJSON();
					return (
						item.ID ==
						enums.CauseAttributeTypes
							.AmountToAutoTransferToDebitCardAtLowBalance
					);
				});

				var reload = data.filter(function (model) {
					var item = model.toJSON();
					return (
						item.ID == enums.CauseAttributeTypes.AutoAmountTransferToDebitCard
					);
				});

				this.$('.js-bank-reload-balance').removeClass('error');
				this.$('.js-bank-reload-amount').removeClass('error');

				if (balance && amt) {
					// console.log('balance', this.$(".js-bank-reload-balance"))
					// console.log('balance model', balance)
					this.$('.js-bank-reload-balance')
						.find('option[value="' + balance[0].Name.replace(',', '') + '"]')
						.prop('selected', true);
					this.$('.js-bank-reload-amount')
						.find('option[value="' + amt[0].Name.replace(',', '') + '"]')
						.prop('selected', true);

					// Because there are already amounts here, update the success/error messaging
					this.reload_bank_button.updateErrorMessage(
						'Auto-Reload could not be updated.'
					);
					this.reload_bank_button.updateSuccessMessage('Changes saved.');

					if (reload[0].Name == '1') {
						this.$('.js-bank-reload').prop('checked', true);

						this.$('.js-bank-reload-details').show();
					} else if (reload[0].Name == '0') {
						this.$('.js-bank-reload').prop('checked', false);

						this.$('.js-bank-reload-details').hide();
					}
				}
			}
		},

		addReloadBalanceOptions: function () {
			var that = this;

			// Ensure it is cleared before adding options
			that.$('.js-bank-reload-balance').html('');

			this.reload_balance_limits.each(function (limit) {
				that
					.$('.js-bank-reload-balance')
					.append(
						'<option value=' + limit.ID + '>$ ' + limit.Name + '</option>'
					);
			});
		},

		addReloadAmountOptions: function () {
			var that = this;

			// Ensure it is cleared before adding options
			that.$('.js-bank-reload-amount').html('');

			this.reload_amount_limits.each(function (limit) {
				that
					.$('.js-bank-reload-amount')
					.append(
						'<option value=' + limit.ID + '>$ ' + limit.Name + '</option>'
					);
			});
		},

		reloadFromBank: function (processComplete, that) {
			var that = that ? that : this,
				reload_form_valid = true,
				reload_form_balance_valid = true,
				reload_form_amount_valid = true;

			if (!that.validateReloadBalance()) {
				reload_form_valid = false;
				reload_form_balance_valid = false;
			}

			if (!that.validateReloadAmount()) {
				reload_form_valid = false;
				reload_form_amount_valid = false;
			}

			if (
				(that.bank_transfer_details && reload_form_valid) ||
				(!reload_form_balance_valid && !reload_form_amount_valid)
			) {
				var checkbox = that.$('.js-bank-reload'),
					url =
						pf.userURL +
						'/Settings/CardLimits/?AutoLoad=' +
						checkbox.is(':checked'),
					balance = that.$('.js-bank-reload-balance'),
					amount = that.$('.js-bank-reload-amount'),
					bank_transfer = that.bank_transfer_details.toJSON();

				balance.removeClass('error');
				amount.removeClass('error');

				if (checkbox.is(':checked')) {
					var data = [
						{
							N: balance.val() == '-1' ? 0 : balance.val(),
							I: enums.CauseAttributeTypes.LowBalanceThresholdAmount,
						},
						{
							N: amount.val() == '-1' ? 0 : amount.val(),
							I: enums.CauseAttributeTypes
								.AmountToAutoTransferToDebitCardAtLowBalance,
						},
						{
							N:
								bank_transfer.ExpediteB2CRequestAllowed == true &&
								bank_transfer.CardBalance >= 0
									? 2
									: 1,
							I: enums.CauseAttributeTypes.ACHServiceType,
						},
						{
							N: true,
							I: enums.CauseAttributeTypes.AutoAmountTransferToDebitCard,
						},
					];
				} else {
					var data = [
						{
							N: 0,
							I: enums.CauseAttributeTypes.LowBalanceThresholdAmount,
						},
						{
							N: 0,
							I: enums.CauseAttributeTypes
								.AmountToAutoTransferToDebitCardAtLowBalance,
						},
						{
							N:
								bank_transfer.ExpediteB2CRequestAllowed == true &&
								bank_transfer.CardBalance >= 0
									? 2
									: 1,
							I: enums.CauseAttributeTypes.ACHServiceType,
						},
						{
							N: false,
							I: enums.CauseAttributeTypes.AutoAmountTransferToDebitCard,
						},
					];
				}

				$.ajax({
					type: 'POST',
					async: false,
					url: url,
					contentType: 'application/json',
					data: JSON.stringify(data),
					success: function (response) {
						if (checkbox.is(':checked')) {
							that.reload_bank_button.updateSuccessMessage(
								"You're all set. Funds will be transferred automatically to your PayForward account."
							);
						} else {
							that.reload_bank_button.updateSuccessMessage(
								"You're all set. Funds will be not be transferred automatically to your PayForward account."
							);
						}

						if (processComplete.name) {
							that.reload_bank_button[processComplete.name](true);
						} else {
							processComplete(true, that.reload_bank_button);
						}
					},
					error: function (resp, model) {
						// that.showCipRerouteMessage(function(did_show){
						//     if(!did_show){
						//         pfdialog.error({ context: that, Body: "Please try again.", Title: "Error" });
						//         var text = 'Could not verify bank account';
						//         that.reload_bank_button.updateErrorMessage(text);
						//         if(processComplete.name){
						//             that.reload_bank_button[processComplete.name](false);
						//         } else {
						//             processComplete(false, that.reload_bank_button);
						//         }
						//     }
						// });
					},
				});
			} else {
				if (!reload_form_amount_valid && !reload_form_balance_valid) {
					var text = 'Please adjust balance and amount';
				} else if (!reload_form_amount_valid) {
					var text = 'Select a reload amount that is greater than balance';
				} else if (!reload_form_balance_valid) {
					var text = 'Please select a valid balance';
				} else if (!that.bank_transfer_details) {
					console.log(
						'Bank account data doesnt exist',
						that.bank_transfer_details
					);
					var text = 'Could not verify bank account';
				} else {
					console.log('Bank account data generic');
					var text = 'Could not verify bank account';
				}

				that.reload_bank_button.updateErrorMessage(text);

				if (processComplete.name) {
					that.reload_bank_button[processComplete.name](false);
				} else {
					processComplete(false, that.reload_bank_button);
				}
			}
		},

		validateReloadBalance: function () {
			var is_valid = true,
				checkbox = this.$('.js-bank-reload'),
				balance = this.$('.js-bank-reload-balance'),
				amount = this.$('.js-bank-reload-amount');

			if (balance.val() == '-1' && checkbox.is(':checked') == true) {
				balance.addClass('error');
				is_valid = false;
			} else if (
				parseInt(balance.val()) > parseInt(amount) &&
				parseInt(amount) > 0 &&
				amount != -1
			) {
				balance.addClass('error');
				is_valid = false;
			} else {
				balance.removeClass('error');
			}

			return is_valid;
		},

		validateReloadAmount: function () {
			var is_valid = true,
				checkbox = this.$('.js-bank-reload'),
				balance = this.$('.js-bank-reload-balance'),
				amount = this.$('.js-bank-reload-amount');

			if (amount.val() == '-1' && checkbox.is(':checked') == true) {
				amount.addClass('error');
				is_valid = false;
			} else if (
				parseInt(amount.val()) < parseInt(balance.val()) &&
				parseInt(balance.val()) > 0 &&
				balance.val() != -1
			) {
				amount.addClass('error');
				is_valid = false;
			} else {
				amount.removeClass('error');
			}

			return is_valid;
		},

		cancelReloadFromBank: function (that) {
			var that = that ? that : this;

			// Hide the Reload form
			that.$('.js-linked-accounts-bank-reload-form-container').hide();
			that.$('.js-linked-accounts-reload').hide();

			// Show Bank Account
			that.showBankAccount();
		},

		reloadFromBankSuccess: function (resetButtonState, that) {
			var that = that ? that : this;

			// Reset Balance and Amount Selects
			that.$('.js-bank-reload-balance').prop('selectedIndex', 0);
			that.$('.js-bank-reload-amount').prop('selectedIndex', 0);

			// Hide the Reload form
			that.$('.js-linked-accounts-bank-reload-form-container').hide();
			that.$('.js-linked-accounts-reload').hide();

			// Show Bank Account
			that.showBankAccount();

			if (resetButtonState.name) {
				that.reload_bank_button[resetButtonState.name]();
			} else {
				resetButtonState(that.reload_bank_button);
			}
		},

		canceledReloadFromyBankOnError: function (that) {
			// console.log('canceledReloadFromyBankOnError',that);
		},

		removeBank: function (e) {
			if (e && e.preventDefault) {
				e.preventDefault();
			}
			if (e && e.stopPropagation) {
				e.stopPropagation();
			}

			var that = this;

			that.remove_bank_alert_modal_view = new AlertModalView({
				// General
				calling_view: that,
				alert_type: 1,
				// Transactional
				is_transaction: false,
				// Content
				alert_header: 'Remove account',
				alert_message: 'Are you sure you want to remove the linked account',
				// Default
				btn_label: 'Remove Bank',
				btn_color: 'red',
				btn_callback: that.removeBankMODAL,
				btn_retry_callback: that.removeBankMODAL,
				// Confirm
				btn_confirm: false,
				// Cancel
				btn_cancel: true,
				btn_cancel_label: 'Cancel',
				btn_cancel_callback: that.cancelRemoveBankMODAL,
				// Success
				btn_success: true,
				btn_success_delay: 700,
				btn_success_label: 'OK',
				btn_success_message: 'Successfully removed the linked account',
				btn_success_callback: that.removeBankSuccess,
				// Error
				btn_error: true,
				btn_error_delay: 700,
				btn_error_label: 'Retry',
				btn_error_cancel_label: 'Cancel',
				btn_error_message: 'Please try again.',
				btn_error_callback: that.canceledRemoveBankOnError,
			});

			that.alert_modal = new Modal({
				show: true,
				content: that.remove_bank_alert_modal_view.$el.html(),
				calling_view: that.remove_bank_alert_modal_view,
			});
		},

		removeBankMODAL: function (processComplete, that) {
			var that = that ? that : this;

			$.ajax({
				type: 'DELETE',
				url: pf.consumerURL + '/RemoveBankAccount',
				contentType: 'application/json',
				success: function (model, resp) {
					if (processComplete.name) {
						that.remove_bank_alert_modal_view[processComplete.name](true);
					} else {
						if (_.isFunction(processComplete)) {
							processComplete(true, that.remove_bank_alert_modal_view);
						}
					}
				},
				error: function (resp, model) {
					if (processComplete.name) {
						that.remove_bank_alert_modal_view[processComplete.name](false);
					} else {
						if (_.isFunction(processComplete)) {
							processComplete(false, that.remove_bank_alert_modal_view);
						}
					}
				},
			});
		},

		removeBankSuccess: function (resetButtonState, that) {
			var that = that ? that : this;
			that.$('.js-linked-accounts-bank').hide();
			that.$('.js-link-bank-btn').show();
			that.closeMODAL();
		},

		cancelRemoveBankMODAL: function () {
			// console.log('cancelRemoveBankMODAL');
		},

		canceledRemoveBankOnError: function () {
			// console.log('canceledRemoveBankOnError');
		},

		closeMODAL: function () {
			$('#pf-modal-modern').fadeOut(function () {
				$('#pf-modal-modern').remove();
			});
		},

		close: function () {},
	});
});

